import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import { generateXB3TraceID, getChannelID, getHost, isSsr, getTmxId, } from '../utils/general';
var baseurl = getHost();
var channelId = getChannelID();
var TMXProfileID = isSsr ? '' : getTmxId();
var baseConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        'X-B3-TraceId': generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
var apiBase = axios.create(baseConfig);
export { apiBase };
